import React from "react";
import { SnackbarProvider } from "notistack";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "./axiosUnauthorizedInterceptor";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import "antd/dist/antd.css";

// antd components (Table, Modal, ...) use ResizeObserver internally, which can throw this
// benign "loop completed" event when its callback queue can't drain within a frame. It isn't
// a real error, but CRA's dev-mode error overlay registers its window.onerror handler before
// this module runs, so listening for the event afterward is too late to stop it from firing.
// Patching the constructor to defer callbacks a frame prevents the condition altogether.
const NativeResizeObserver = window.ResizeObserver;
if (NativeResizeObserver) {
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// const root = ReactDOM.createRoot(document.getElementById("root"));
ReactDOM.render(
  <>
    <Provider store={store}>
      <SnackbarProvider maxSnack={5}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SnackbarProvider>
    </Provider>
  </>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
